import React, { useEffect, useState } from "react";
import { Box, TextField } from "@mui/material";

const formatNumber = (val) => {
  if (val === "" || val === null || val === undefined) return val;
  const n = Number(val);
  if (!Number.isFinite(n)) return val;
  return n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const EditableCell = ({ value, handleSaveCell, cell, row, sx }) => {
  const [localValue, setLocalValue] = useState(formatNumber(value ?? ""));

  useEffect(() => {
    setLocalValue(formatNumber(value ?? ""));
  }, [value]);

  return (
    <TextField
      type="text"
      size="small"
      variant="standard"
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      onBlur={() =>
        handleSaveCell(
          { row, column: cell.column },
          localValue === "" ? "" : localValue
        )
      }
      fullWidth
      sx={sx}
      inputProps={{ style: { textAlign: "right" } }}
    />
  );
};

const EstimationColumns = (getValues, handleSaveCell) => [
  {
    accessorKey: "WBS Code",
    header: "WBS Code",
    size: 80,
    enableEditing: false,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: {
      sx: {
        textAlign: "center",
        borderRight: "none",
        fontWeight: "bold",
      },
    },
  },
  {
    accessorKey: "Description",
    header: "Task Description",
    size: 260,
    enableEditing: false,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: {
      sx: {
        textAlign: "left",
        fontWeight: "bold",
      },
    },
  },
  {
    accessorKey: "Unit",
    header: "Unit",
    size: 80,
    enableEditing: false,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: {
      sx: {
        textAlign: "center",
      },
    },
  },
  {
    accessorKey: "Est Weight",
    header: "Est Unit",
    size: 100,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { sx: { textAlign: "right" } },
    Cell: ({ cell, row }) =>
      ["2.1", "2.2", "3.1", "3.2"].includes(row.original["WBS Code"]) ? (
        <Box sx={{ textAlign: "right", width: "100%" }}>
          {formatNumber(row.original["Est Weight"])}
        </Box>
      ) : (
        <EditableCell
          value={row.original["Est Weight"]}
          handleSaveCell={handleSaveCell}
          cell={cell}
          row={row}
          sx={{ textAlign: "right" }}
        />
      ),
  },
  {
    accessorKey: "Est Unit Rate",
    header: "Est Unit Rate",
    size: 110,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { sx: { textAlign: "right" } },
    Cell: ({ cell, row }) => (
      <EditableCell
        value={row.original["Est Unit Rate"]}
        handleSaveCell={handleSaveCell}
        cell={cell}
        row={row}
        sx={{ textAlign: "right" }}
      />
    ),
  },
  {
    accessorKey: "Est Cost",
    header: "Est Cost ($)",
    size: 110,
    enableEditing: false,
    enableSorting: false,
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { sx: { paddingRight: 2 } },
    Cell: ({ row }) => (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box sx={{ color: "text.secondary" }}>$</Box>
        <Box>{formatNumber(row.original["Est Cost"])}</Box>
      </Box>
    ),
  },
];

export default EstimationColumns;